import React, { useState } from 'react';
import { TabsList, Tabs, TabsTrigger, TabsContent } from "@/components/UI/tabs";
import ServiceAgreement from './ServiceAgreements';
import Invoice from './Invoice';  // Updated import path
import { useNavigate } from 'react-router-dom';

const AccountsTwo = () => {
    const [activeTab, setActiveTab] = useState('dashboard');
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <header className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-6 py-4">
                    <div className="flex justify-between items-center">
                        <div className="flex flex-col">
                            <h1 className="text-xl font-bold text-gray-900">
                                Accounts Management
                            </h1>
                            <span className="text-sm text-gray-500">
                                {new Date().toLocaleDateString('en-US', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                })}
                            </span>
                        </div>
                        <button
                            onClick={handleLogout}
                            className="px-4 py-2 text-gray-700 hover:text-gray-900"
                        >
                            Sign out
                        </button>
                    </div>
                </div>
            </header>

            {/* Navigation */}
            <div className="bg-white border-b">
                <div className="max-w-7xl mx-auto">
                    <Tabs value={activeTab} onValueChange={setActiveTab}>
                        <TabsList className="flex border-b w-full">
                            <TabsTrigger 
                                value="dashboard" 
                                className="px-6 py-3 text-sm font-medium border-b-2 border-transparent data-[state=active]:border-blue-500"
                            >
                                Dashboard
                            </TabsTrigger>
                            <TabsTrigger 
                                value="agreements" 
                                className="px-6 py-3 text-sm font-medium border-b-2 border-transparent data-[state=active]:border-blue-500"
                            >
                                Service Agreements
                            </TabsTrigger>
                            <TabsTrigger 
                                value="invoices" 
                                className="px-6 py-3 text-sm font-medium border-b-2 border-transparent data-[state=active]:border-blue-500"
                            >
                                Invoices
                            </TabsTrigger>
                            <TabsTrigger 
                                value="payments" 
                                className="px-6 py-3 text-sm font-medium border-b-2 border-transparent data-[state=active]:border-blue-500"
                            >
                                Payments
                            </TabsTrigger>
                        </TabsList>

                        <div className="py-6">
                            <TabsContent value="dashboard">
                                <div className="bg-white rounded-lg shadow-sm p-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                                        Dashboard Overview
                                    </h2>
                                    <div className="bg-gray-50 rounded-lg p-8 text-center">
                                        <p className="text-gray-600">
                                            Power BI dashboard visualizations will be integrated here soon.
                                        </p>
                                    </div>
                                </div>
                            </TabsContent>

                            <TabsContent value="agreements">
                                <ServiceAgreement />
                            </TabsContent>

                            <TabsContent value="invoices">
                                <Invoice />
                            </TabsContent>

                            <TabsContent value="payments">
                                <div className="bg-white rounded-lg shadow-sm p-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                                        Payments
                                    </h2>
                                    <div className="bg-gray-50 rounded-lg p-8 text-center">
                                        <p className="text-gray-600">
                                            Payment management functionality will be available soon.
                                        </p>
                                    </div>
                                </div>
                            </TabsContent>
                        </div>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default AccountsTwo;
